import { useSelector } from 'react-redux';

const useAdabtiveMultiSizeImage = () => {
  const { isCrawler, deviceType } = useSelector((state) => state.globalData);

  const adaptCMSImage = (imageObj) => {
    const result = {};

    // eslint-disable-next-line no-restricted-syntax
    for (const sizeKey in imageObj) {
      if (
        // eslint-disable-next-line no-prototype-builtins
        imageObj.hasOwnProperty(sizeKey)
        && imageObj[sizeKey]
        && imageObj[sizeKey].url
      ) {
        result[sizeKey] = imageObj[sizeKey].url;
      } else {
        result[sizeKey] = imageObj[sizeKey];
      }
    }

    return result;
  };

  const getSizedImage = (imageSizes) => {
    let imageObj = imageSizes;
    if (typeof imageObj.small_url !== 'string') imageObj = adaptCMSImage(imageSizes);

    if (deviceType === 'mobile' || isCrawler) {
      return imageObj.small_url;
    }
    if (deviceType === 'tablet') {
      return imageObj.medium_url;
    }
    if (deviceType === 'desktop') {
      return imageObj.large_url;
    }
    return imageObj.xlarge_url || imageObj.large_url;
  };

  return getSizedImage;
};

export default useAdabtiveMultiSizeImage;
